import $ from "jquery";

const hideFooterAndBreadcrumbOnLoginRegister = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const page = $(
      ".woocommerce-form-login, .woocommerce-ResetPassword"
    ).length;
    if (page < 1) return;

    $(".js-section-breadcrumb").css("display", "none");
    $(".elementor-location-footer").css("display", "none");
  };

  init();
};

try {
  // hideFooterAndBreadcrumbOnLoginRegister();
} catch (error) {
  console.log(error);
}
